<template>
  <div class="fs12 tc rel" style="height: 0.16rem">
    <img
      v-if="+type === 1"
      src="https://static.wkanx.com/w002/M00/07/DE/CgIXgV9YSteAJzNFAAAJ7AhQk1Y768.png"
      style="height: 0.18rem"
    />
    <img
      v-else
      src="https://static.wkanx.com/w002/M00/07/DE/CgIXGF9YVWeAe74LAAAKM0wJHXw133.png"
      style="height: 0.15rem"
      alt=""
    />
    <Menu class="abs-center-v" :type="menuType" style="height: 0.09rem" />
  </div>
</template>
<script>
import Menu from './Menu';
export default {
  name: '',
  components: { Menu },
  props: {
    type: { type: [String, Number], default: 1 },
    menuType: { type: String, default: 'dark' },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.menu {
  right: 0.1rem;
}
</style>
